<script setup lang="ts">
defineProps<{
  error?: string;
}>();
</script>

<template>
  <span
    v-if="error"
    class="my-1.5 flex items-center gap-1 text-xs font-semibold text-red-600"
  >
    <span class="pi pi-exclamation-circle text-xs"></span>

    {{ $t(error) }}
  </span>
</template>
